'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function HeroTitle({
  tag = 'h1',
  resourceKey = 'modules.shared.HeroTitle',
  params,
  titleText,
}) {
  const title = titleText
    ? h(`${tag}.hero-title-text`, titleText)
    : h(
        Translate,
        { tag, attrs: { class: 'hero-title-text' }, ...params },
        resourceKey
      );

  return h(
    '.hero-title',
    h(
      '.page-container',
      h('.row', h('.hero-title-inner.twelve.columns', title))
    )
  );
}

module.exports = HeroTitle;
